import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Floating dugme (fiksirano desno, vertikalno centrirano) koje skroluje do liste redovnih
// loyalty artikala (.loyalty-table-content, id="loyalty-products-table" u LoyaltyShopPage.js).
// Ljubicasta boja je hover stanje, zuta je obicno stanje - po dizajnu.
const LoyaltyScrollToProductsButton = ({ targetId = 'loyalty-products-table' }) => {
    const { t } = useTranslation('loyalty');
    const [isHover, setIsHover] = useState(false);

    const handleClick = () => {
        const target = document.getElementById(targetId);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <button
            type="button"
            className={`loyalty-scroll-fab ${isHover ? 'loyalty-scroll-fab-hover' : ''}`}
            onClick={handleClick}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            <span className="loyalty-scroll-fab-text">
                <span className="loyalty-scroll-fab-text-bold">{t('floatingBtnBold')}</span> <span className="loyalty-scroll-fab-text-light">{t('floatingBtnLight')}</span>
            </span>
            <img src={`${process.env.PUBLIC_URL}/media/loyalty-arrow-down.svg`} alt="" className="loyalty-scroll-fab-icon" />
        </button>
    );
};

export default LoyaltyScrollToProductsButton;
